var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_5478)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_172_5478)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDE6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 22,
    r: 2,
    fill: "#1AD586"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 22,
    r: 2,
    fill: "#1AD586"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 12,
    fill: "#F26D6B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_172_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2);
export default __webpack_public_path__ + "static/media/face_2.084ee1903c661063b800b2770895f0fa.svg";
export { ForwardRef as ReactComponent };